
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IPublicPageSlug } from './slug.model';

@Injectable({ providedIn: 'root' })
export class SlugsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${SlugsService.ENDPOINT}`; }
    private static readonly ENDPOINT = 'publicpages/{publicPageId}/slugs';

    public getPublicPageSlug(publicPageId: string): Observable<SuccessResponse<IPublicPageSlug> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IPublicPageSlug>>(SlugsService.URL.replace('{publicPageId}', publicPageId)).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public addPublicPageSlug(publicPageId: string, value: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(SlugsService.URL.replace('{publicPageId}', publicPageId), { value }).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public updatePublicPageSlug(publicPageId: string, value: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(SlugsService.URL.replace('{publicPageId}', publicPageId), { value }).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public deletePublicPageSlug(publicPageId: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(SlugsService.URL.replace('{publicPageId}', publicPageId)).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
